import { Directive, Input } from "@angular/core";
import { NzRowIndentDirective } from "ng-zorro-antd/table";

@Directive({
  selector: "ui-row-indent",
})
export class UiRowIndentDirective extends NzRowIndentDirective {
  @Input("indentSize") public indentSize = 0;
}
